$(document).ready(function(){

	if($('#map').length > 0) {
		initMap();
	}

	function initMap() {
  	var coords = {lat: 49.617868, lng: 6.142687};

		// -- Init map --
	  var map = new google.maps.Map(document.getElementById('map'), {
	  	zoom: 16, 
	  	center: coords
	  });
	  
	  // -- Add marker --
  	var marker = new google.maps.Marker({position: coords, map: map});
	}

});